//libs
import React, { memo } from 'react';

// constants
import { COLORS } from 'shared/styles/base';

//styles
import { ProgressContainer, ProgressContent } from './styles';

interface IProgressBarProps {
  min: number;
  max: number;
  value: number;
  height: number;
  maxWidth: number;
  backgroundColor: string;
  foregroundColor: string;
  className: string;
}

function ProgressBar({
  min = 0,
  max = 100,
  value = 0,
  height = 4,
  maxWidth = 240,
  backgroundColor = COLORS.BLACK_16, // TODO: change to tokens
  foregroundColor = COLORS.BLACK_64, // TODO: change to tokens
  className,
}: Partial<IProgressBarProps>) {
  const val = (value * 100) / max;

  return (
    <ProgressContainer
      className={className}
      height={height}
      maxWidth={maxWidth}
      backgroundColor={backgroundColor}
    >
      <ProgressContent
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        className="progress-content"
        height={height}
        value={val}
        foregroundColor={foregroundColor}
      />
    </ProgressContainer>
  );
}

export default memo(ProgressBar);
